var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.724562 1.14107C0.946451 0.919177 1.29367 0.899006 1.53835 1.08055L1.60845 1.14107L6.99984 6.53218L12.3912 1.14107C12.6131 0.919177 12.9603 0.899006 13.205 1.08055L13.2751 1.14107C13.497 1.36295 13.5172 1.71017 13.3356 1.95485L13.2751 2.02495L7.44178 7.85828C7.21989 8.08017 6.87267 8.10034 6.62799 7.9188L6.5579 7.85828L0.724562 2.02495C0.480484 1.78087 0.480484 1.38514 0.724562 1.14107Z",
    fill: "#222732"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownMenu);
export default __webpack_public_path__ + "static/media/arrow-down-menu.203d7d4251d7fb36e776436cb18d58bf.svg";
export { ForwardRef as ReactComponent };